import React from "react";

import AccountAreaContainer from "./AccountAreaContainer";
import Announcement from "./Announcement";
import Alerts from "./Alerts";
import MarqueeArea from "./MarqueeArea";
import Profile from "./Profile";

const AccountArea = (props) =>
	(<AccountAreaContainer>
		<ul className="account-area">
			<Announcement />{/* new features, breaking news */}
			<Alerts />{/* algorithm progress updates */}
			<MarqueeArea />{/* sparkline of BSE, NSE rotate to time of day, Fav stocks */}
			<Profile />{/* change theme, Signout, Go to profile page */}
		</ul>
	</AccountAreaContainer>);

export default AccountArea;



/** WEBPACK FOOTER **
 ** ./src/scripts/components/header/AccountArea.jsx
 **/